export enum enumCreateTEN {
  'First Time' = 1,
  'Each Presentment'
}

export namespace enumCreateTEN {
  export function values() {
    return Object.keys(enumCreateTEN).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
